import clsx from "clsx";
import { merosZustandLabel, type MerosZustand } from "@/lib/meros";

export function MerosZustandBadge({
  zustand,
  prefix = "Merostützen",
  size = "sm",
}: {
  zustand: MerosZustand | null | undefined;
  prefix?: string;
  size?: "sm" | "lg";
}) {
  if (zustand !== "oben" && zustand !== "unten") return null;
  const oben = zustand === "oben";
  return (
    <span
      className={clsx(
        "inline-flex rounded-full font-semibold tracking-wide",
        size === "lg" ? "px-3 py-1 text-lg" : "px-2 py-0.5 text-xs",
        oben ? "bg-accent-soft text-accent" : "bg-fill-secondary text-label",
      )}
    >
      {prefix ? `${prefix} ` : ""}
      {merosZustandLabel(zustand)}
    </span>
  );
}
